import FreeCodeCampCert from '../assets/freecodecamp.png'
import sqlHackerRankCert from '../assets/SQL_Intermediate_Certificate.png'
import restApiHackerRankCert from '../assets/Rest_API_Intermediate_Certificate.png'
import GetStartNvidiaCert from '../assets/Getting_Started_with_Deep_Learning.png'
import BuildingNvidiaCert from '../assets/Building_Real_Time_Video_AI_Applications.png'
import MachineLCourseraCert from '../assets/Machine_Learning_with_Python.jpeg'
import SupervisedMachineLearningCert  from '../assets/Supervised_Machine_Learning.jpeg'
import ElevvoCertificate from '../assets/elovvo-certificate.png'
import JavaScript_1_certificate from "../assets/JavaScript_1_certificate.png"

export const data = [
{
    id: 1,
    title: "Back End Development and APIs",
    issuer: "FreeCodeCamp",
    date: "2024",
    link: "https://www.freecodecamp.org/certification/fcc-1346c7d0-caef-4a60-88c3-f29250a3e0fe/back-end-development-and-apis",
    description: "Advanced backend development with Node.js, Express, and APIs",
    image: FreeCodeCampCert,
    badgeColor: "from-green-500 to-green-600"
},
{
    id: 2,
    title: "SQL (Intermediate)",
    issuer: "HackerRank",
    date: "2024",
    link: "https://www.hackerrank.com/certificates/87fac1bab609",
    description: "Advanced SQL queries, joins, and database optimization",
    image: sqlHackerRankCert,
    badgeColor: "from-green-500 to-green-600"
},
{
    id: 3,
    title: "REST API (Intermediate)",
    issuer: "HackerRank", 
    date: "2024",
    link: "https://www.hackerrank.com/certificates/iframe/960a375e4cad",
    description: "Algorithm design and problem-solving techniques",
    image: restApiHackerRankCert,
    badgeColor: "from-green-500 to-green-600"
},
{
    id: 4,
    title: "Fundamentals of Deep Learning",
    issuer: "NVIDIA",
    date: "2024",
    link: "https://learn.nvidia.com/certificates?id=7AxjRcuaQoCQvdyA4QGVSA",
    description: "Deep learning fundamentals and neural networks",
    image: GetStartNvidiaCert, 
    badgeColor: "from-green-700 to-green-800"
},
{
    id: 5,
    title: "Building Real-Time Video AI Applications",
    issuer: "NVIDIA",
    date: "2024", 
    link: "https://learn.nvidia.com/certificates?id=bEldEF7rSz-lQcDFtpgVZw",
    description: "Advanced real-time video AI applications and processing",
    image: BuildingNvidiaCert, 
    badgeColor: "from-green-700 to-green-800"
},
{
    id: 6,
    title: "Machine Learning with Python",
    issuer: "Coursera",
    date: "2024",
    link: "https://www.coursera.org/account/accomplishments/verify/7KRZDNDDF3YT",
    description: "Machine learning algorithms and Python implementation",
    image: MachineLCourseraCert,
    badgeColor: "from-green-500 to-green-600"
},
{
    id: 7,
    title: "Supervised Machine Learning",
    issuer: "Coursera",
    date: "2024",
    link: "https://www.coursera.org/account/accomplishments/verify/75BKN4NZGWLN",
    description: "Supervised learning techniques and applications",
    image: SupervisedMachineLearningCert,
    badgeColor: "from-green-500 to-green-600"
},
{
    id: 8,
    title: "Elevvo Certificate",
    issuer: "Elevvo",
    date: "2024",
    link: "https://drive.google.com/file/d/1W9BPBAqo1zy1hCmgXoSOzaOm8rrbqPaD/view?usp=sharing",
    description: "Elevvo internship certification in front-end",
    image: ElevvoCertificate,
    badgeColor: "from-green-500 to-green-600"
},{
    id: 9,
    title: "JavaScript Essentials 1",
    issuer: "Cisco Networking Academy",
    date: "2024",
    link: "https://www.credly.com/badges/efe4e1dc-a341-47a1-8598-fef57e608f5d/public_url",
    description: "JavaScript Essentials 1 certification",
    image: JavaScript_1_certificate,
    badgeColor: "from-green-500 to-green-600"
}
]